module.exports = __webpack_public_path__ + "static/carousel-06@2x-137bf9d047f9d224747508af1dd634b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/about-us/carousel-06@2x.jpg
// module id = 2523
// module chunks = 168707334958949